import { useState } from 'react'

interface Props {
  url?: string | null
  name?: string | null
  /** Sizing classes for the element, e.g. "w-12 h-12". */
  className?: string
  /** Font-size class for the initial fallback, e.g. "text-lg". */
  textClassName?: string
}

/**
 * Circular avatar that falls back to the person's initial on a missing OR
 * broken image URL (a 404'd avatar otherwise shows the browser's broken-image
 * glyph). Use everywhere a list row shows a small avatar.
 */
export default function Avatar({ url, name, className = 'w-12 h-12', textClassName = 'text-lg' }: Props) {
  const [failed, setFailed] = useState(false)
  const initial = (name ?? '').trim().charAt(0).toUpperCase() || '?'

  if (url && !failed) {
    return (
      <img
        src={url}
        alt={name ?? ''}
        onError={() => setFailed(true)}
        className={`${className} rounded-full object-cover flex-shrink-0 bg-ivory-100`}
      />
    )
  }
  return (
    <div
      className={`${className} rounded-full flex items-center justify-center flex-shrink-0 bg-maroon-700 text-champagne font-display font-semibold ${textClassName} ring-1 ring-gold-500/40`}
    >
      {initial}
    </div>
  )
}
